import posthog from 'posthog-js';

/**
 * The redesign of the messaging onboarding (Figma "Gynger app – Messagerie",
 * "✨ New screens"): the homepage messaging card, the story slides, the
 * messaging page, the team page, the conversation's first steps and the new
 * message bubbles and composer.
 */
export const MESSAGING_EXPLAINER_V3_FLAG = 'messaging-explainer-v3';

/** Where a functional test stores its own flag overrides (see `applyFeatureFlagOverrides`). */
export const E2E_FEATURE_FLAGS_STORAGE_KEY = 'gynger.e2e.featureFlags';

export function isMessagingExplainerV3Enabled() {
  return posthog.isFeatureEnabled(MESSAGING_EXPLAINER_V3_FLAG) === true;
}

/**
 * Mirrors the flag on `<html data-messaging="v3">`, which switches the chat
 * tokens to the redesign's (see index.css).
 */
export function syncMessagingExplainerV3Attribute() {
  if (isMessagingExplainerV3Enabled()) {
    document.documentElement.dataset.messaging = 'v3';
  } else {
    delete document.documentElement.dataset.messaging;
  }
}
